import MainTemplate from "../mainTemplate";
import Modal from '../../utils/customModal';
import { ReactTitle } from "react-meta-tags";
import NotificationForm from "./notificationForm";
import React, { useEffect, useState } from "react";
import { loadingHtml } from '../../utils/functions';
import { useDispatch, useSelector } from "react-redux";
import { getRoles } from "../../../Redux/reducer/session";
import { getNotificationById, clearNotification } from "../../../Redux/actions/notificationsAction";

const NotificationDetail = (props) => {
  const dispatch = useDispatch();

  const [group, setGroup] = useState({
   
    nameTypeNotificationEmailEs: "",
    descriptionTypeNotificationEmailEs : "",
    nameTypeNotificationEmailEn: "",
    descriptionTypeNotificationEmailEn : "",
    isDeleted : ''
  });
  const [edit, setEdit] = useState(false);
  const [modal, setModal] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const roles = useSelector(state => getRoles(state));
  const title = props.match.params.id !== undefined ? 'Editar grupo' : 'Agregar grupo';

  useEffect(() => {
    async function fetchData() {
      return await dispatch(getNotificationById(props.match.params.id));
    }

    if (props.match.params.id !== undefined) {
      setModal(true);
      setEdit(true);
      fetchData().then((response) => {
        setReadOnly(true);
        setModal(false);

        var data = response.data;
        // var actions = [];
        // Object.keys(data.actions).map(
        //   (key) => (actions[data.actions[key]] = true)
        // );

        setGroup({
          nameTypeNotificationEmailEs: data.nameTypeNotificationEmailEs,
          descriptionTypeNotificationEmailEs: data.descriptionTypeNotificationEmailEs,
          nameTypeNotificationEmailEn: data.nameTypeNotificationEmailEn,
          descriptionTypeNotificationEmailEn: data.descriptionTypeNotificationEmailEn,
          isDeleted: data.isDeleted
        });
      });
    }

    return () => {
      dispatch(clearNotification());
    }
  }, []);


  return (
    <MainTemplate>
      <ReactTitle title={`${title} - Reverse Factoring`} />
      <NotificationForm roles={roles} groupid={props.match.params.id} readOnly={readOnly} group={group} edit={edit} history={props.history} />
      <Modal show={modal}>{loadingHtml()}</Modal>
    </MainTemplate>
  );
};

export default NotificationDetail;
